import gsap from 'gsap'
import React, { useLayoutEffect, useRef } from 'react'
const Photocouple = ({details}) => {

  const sectionRef = useRef(null)
  const backgroundRef = useRef(null)
  const cardRef = useRef(null)

    const renderPersonCard=({
    image,
    alt,
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  })=>{
     if (!image?.url) return null;
     const baseUrl = image.url;

     return(
       <div className="t3-single-couple-container" data-aos="fade-up">
        <div className="t3-couple-grandparents">
          {grandParentsName && (
            <p>
              {grandParentsPrefix} {grandParentsName}
            </p>
          )}
           </div>
               <img src={baseUrl} 
          alt={alt} 
          srcSet={`
         ${baseUrl.replace('/upload/', '/upload/w_320/')} 320w,
          ${baseUrl.replace('/upload/', '/upload/w_640/')} 640w,
           ${baseUrl.replace('/upload/', '/upload/w_1080/')} 1080w
         `}
           sizes="(max-width: 320px) 320px,
               (max-width: 640px) 640px,
               (max-width: 1080px) 1080px"
          className='t3-couple-image' />
         
         
          <h1 className='t3-couple-name'>{fullname}</h1>
            <div className="t3-couple-parents">
                       {parentsName && (
            <p>
              {parentprefix} {parentsName}
            </p>
          )}
                      </div>
      
       </div>
     )
  }

   const groomCard=()=>{
   return renderPersonCard({
     image:details?.groomImage,
      alt:"groomImage",
       fullname:details?.groomFullName || "Groom Full Name",
      parentprefix:details?.groomParentsPrefix,
      parentsName:details?.groomParents,
      grandParentsPrefix:details?.groomGrandParentsPrefix,
      grandParentsName:details?.groomGrandParents
    }
    )
  }

   const brideCard=()=>
    renderPersonCard({
      image:details?.brideImage,
      alt:"brideImage",
      fullname:details?.brideFullName || "Bride Full Name",
      parentprefix:details?.brideParentsPrefix,
      parentsName:details?.brideParents,
      grandParentsPrefix:details?.brideGrandParentsPrefix,
      grandParentsName:details?.brideGrandParents
    })

 useLayoutEffect(() => {

    const ctx = gsap.context(() => {

      if (!sectionRef.current) return

      const background = backgroundRef.current
      const card = cardRef.current

      if (!background && !card) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 75%",
          once: true,
        }
      })

      if (background) {
        tl.fromTo(
          background,
          {
            autoAlpha: 0
          },
          {
            autoAlpha: 1,
            duration: 1.1,
            ease: "power2.out"
          }
        )
      }

      if (card) {
        tl.fromTo(
          card,
          {
            autoAlpha: 0,
            scale: 0.985
          },
          {
            autoAlpha: 1,
            scale: 1,
            duration: 1,
            ease: "power2.out"
          },
          "-=0.65"
        )
      }

    }, sectionRef)

    return () => ctx.revert()

  }, [])
  return (
    <section className='couple-section photo-couple theme3' ref={sectionRef}>
     <div className="theme-3-couple" ref={backgroundRef} >
     <div className="theme-3-couple-card"  ref={cardRef}>
         <h1 className='t3-couple-heading' data-aos="fade-up">{details?.sectionHeading}</h1>
           <div className="t3-couple-wrapper">
      {details?.displayOrder==="groomFirst"?<>
                    {groomCard()}
                     <span className="t3-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {brideCard()}

            </>:<>
                      {brideCard()}
                         <span className="t3-couple-divider" data-aos="fade-up">
                        &
                    </span>
                       {groomCard()}
            </>}
           </div>
         </div>
     </div>

    </section>
  )
}

export default Photocouple